import { Box, TouchableBox, AHIcon } from "arkh";
import React from "react";

export function TouchPageButtons({
  onPaginate,
}: {
  onPaginate: (page: -1 | 1) => void;
}) {
  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <TouchableBox
        space="small"
        spaceRight="xsmall"
        onPress={() => {
          onPaginate(-1);
        }}
      >
        <Box
          color="lightText"
          shadow="weak"
          space="small"
          cornerRadius="large"
          style={{
            opacity: 0.8,
          }}
        >
          <AHIcon type="chevron-up" />
        </Box>
      </TouchableBox>
      <TouchableBox
        space="small"
        spaceLeft="xsmall"
        onPress={() => {
          onPaginate(1);
        }}
      >
        <Box
          color="lightText"
          shadow="weak"
          space="small"
          cornerRadius="large"
          style={{
            opacity: 0.8,
          }}
        >
          <AHIcon type="chevron-down" />
        </Box>
      </TouchableBox>
    </Box>
  );
}
